import { BaseService } from './BaseService';
import { DownloadRecord } from '../types';

class DownloadService extends BaseService {
  constructor() {
    super('/api/downloads');
  }

  /**
   * Récupère l'historique complet des téléchargements de l'utilisateur connecté.
   */
  async getMyDownloads(): Promise<DownloadRecord[]> {
    try {
      const items = await this.get<any[]>('/my');
      if (!Array.isArray(items)) return [];
      return items.map(i => this.mapDownload(i));
    } catch (error) {
      console.error('DownloadService.getMyDownloads error', error);
      return [];
    }
  }

  /**
   * Enregistre un téléchargement pour un document.
   */
  async recordDownload(documentId: string | number): Promise<DownloadRecord | null> {
    try {
      const data = await this.post<any>(`/record/${documentId}`, {});
      return this.mapDownload(data);
    } catch (error) {
      console.error('DownloadService.recordDownload error', error);
      return null;
    }
  }


  private mapDownload(item: any): DownloadRecord {
    return {
      id: item.id || item.Id,
      documentId: String(item.documentId || item.DocumentId),
      downloadedAt: item.downloadedAt || item.DownloadedAt || item.createdOn || item.CreatedOn,
      officialTitle: item.officialTitle || item.OfficialTitle,
      referenceNumber: item.referenceNumber || item.ReferenceNumber,
      categoryName: item.categoryName || item.CategoryName,
      legalStatus: item.legalStatus || item.LegalStatus,
      fileName: item.fileName || item.FileName,
      pageCount: item.pageCount ?? item.PageCount ?? null
    };
  }
}

export const downloadService = new DownloadService();
